import React, { useState } from 'react'
import DraggableItem from '../../../global/DraggableItem';

const FolderGridView = ({ allFolders, onDelete, moveItem, onThumbnail, onViewImg, locationId, locationData }: any) => {

    const [openMenuId, setOpenMenuId] = useState<number | null>(null);

    return (
        <div
            onClick={() => {
                setOpenMenuId(null)
            }}
            className="lg-grid"
        >
            {allFolders?.map((folder: any, i: any) => (
                <DraggableItem
                    index={i}
                    key={folder?.id}
                    className="lv-card"
                    onClick={() => {
                        if (openMenuId) {
                            setOpenMenuId(null)
                            return
                        }
                        onViewImg(folder, i)
                    }}
                    moveItem={moveItem}
                    itemId={folder?.id}
                    renderType='folder'
                    parentId={locationId}
                    data={folder}
                >
                    <img
                        src={folder?.thumbnail ? folder?.thumbnail : folder?.images?.length > 0 ? folder?.images?.[0]?.image : '/assets/images/empty-folder.svg'}
                        alt={folder?.name}
                        className="lv-card__img"
                        style={{
                            objectFit: folder?.thumbnail ? 'fill' : folder?.images?.length == 0 ? 'cover' : 'fill'
                        }}
                    />
                    <div className="lv-card__overlay">
                        <div onClick={(e) => { e.stopPropagation() }} className="lv-card__info">
                            <span className="lv-card__city">{folder?.name || ''}</span>
                        </div>
                        {locationData?.role != 'V' &&
                            <div className="lv-card__menu-wrap">
                                <button
                                    className="lv-card__menu-btn"
                                    onClick={e => {
                                        e.stopPropagation();
                                        setOpenMenuId(openMenuId === folder?.id ? null : folder?.id);
                                    }}
                                >
                                    <img src='/assets/images/dots-vertical-rounded.svg' alt='more' />
                                </button>
                                {openMenuId === folder?.id && (
                                    <div className="lv-card__menu-dropdown">
                                        <button
                                            className="lv-card__menu-item"
                                            onClick={() => {
                                                onDelete(folder)
                                                setOpenMenuId(null)
                                            }}
                                        >
                                            <img src='/assets/images/Delete-icon-red.svg' />
                                            Delete
                                        </button>
                                        {/* <button
                                        className="lg-info-menu__item"
                                        onClick={() => {
                                            onThumbnail?.(folder)
                                            setOpenMenuId(null)
                                        }}
                                    >
                                        <img width={20} height={20} src='/assets/images/badge-check.svg' />
                                        Use as location key
                                    </button> */}
                                    </div>
                                )}
                            </div>
                        }
                    </div>
                </DraggableItem>
            ))}
        </div>
    )
}

export default FolderGridView